<template>
    <modal content-class="macs-upload-modal"
           :title="$t('message.connections.message.importMacAddresses')"
           :value="showing"
           :maxWidth="500"
           @input="emitShowing">

      <app-form @submit="uploadNewMacAddresses">
        <app-select v-model="form.action"
                    id="macUploadSelect"
                    :data-title="$t('message.connections.message.action')"
                    :data-search="false"
                    :data-items="actions"
                    :error-messages="errors.collect($t('message.connections.message.action'))"
                    :clearable="true"/>

        <dropzone class="macs-upload-modal-file"
                  v-model="form.file"
                  name="Arquivo" />


        <app-button class="macs-upload-modal-action btn btn-primary btn-round"
                    :label="$t('message.connections.message.import')"
                    type="submit"
                    primary />
      </app-form>

    </modal>
  </template>

  <script>
  import EventBus from "@packages/event-bus/index";
  import Dropzone from "@components/form/Dropzone.vue";
  import AppForm from "@components/form/Form.vue";
  import Modal from "@components/generic/Modal.vue";
  import AppButton from "@/components/generic/button/Button";
  import AppSelect from '@components/Select'

  export default {
    components: {
      Modal,
      AppForm,
      AppButton,
      Dropzone,
      AppSelect
    },

    props: {
      showing: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        form: {
          action: undefined,
          file: undefined,
        },
      };
    },

    computed: {
      actions() {
        return [
            {id: 'RELEASE', label: this.$t('message.overview.message.cleared')},
            {id: 'BLOCK', label: this.$t('message.overview.message.blocked')},
        ]
      }
    },

    created() {},

    methods: {
      emitShowing(showing) {
        this.$emit("update:showing", showing);
      },
      async uploadNewMacAddresses() {
        if(!this.form.action) {
          return EventBus.$emit("show-message", {
                type: "ERROR",
                message: "Selecione uma ação"
          });
        }
        let formData = new FormData();
        formData.append("file", this.form.file);
        formData.append("action", this.form.action);

        await this.$api.macAddresses.uploadMacAddresses({
          data: formData,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Endereços MAC adicionados com sucesso!",
        });

        this.emitShowing(false);
        this.$emit("added");
      },
    },
  };
  </script>

  <style lang="scss" >
  .macs-upload-modal {
    .macs-upload-modal-file {
      margin-bottom: 10px;
    }

    #macUploadSelect {
      margin: 0 auto;
      margin-bottom: 10px;

      .dropdown-menu {
        z-index: 999 !important;
      }
    }

    .macs-upload-modal-action {
      margin: 0 auto;
      display: block;
    }

  }
  </style>
